var actions = {
	next: "Weiter",
	confirm: "Bestätigen",
	"continue": "Fortsetzen"
};
var errors = {
	unknown: "Ein unbekannter Fehler ist aufgetreten",
	contactSupport: "Ein Fehler ist aufgetreten. Bitte Support kontaktieren.",
	tryAgain: "Ein Fehler ist aufgetreten. Bitte versuche es erneut.",
	submit: "Bei deiner Einsendung ist ein Fehler aufgetreten."
};
var brands = {
	apple: "Apple",
	facebook: "Facebook",
	google: "Google",
	paypal: "PayPal",
	picarto: "Picarto",
	tiktok: "TikTok",
	trovo: "Trovo",
	twitch: "Twitch",
	youtube: "YouTube",
	twitter: "X (Twitter)",
	linkedin: "LinkedIn",
	streamlabs: "Streamlabs",
	mevo: "Mevo",
	typestudio: "TypeStudio"
};
var loginButton = {
	loginWith: "Mit {name} einloggen",
	signupWith: "Registrieren mit {name}"
};
var alreadyHaveAccount = {
	company: "Du hast schon ein {company} Konto?",
	text: "Du hast schon eine Streamlabs ID?",
	link: "Einloggen"
};
var noAccount = {
	text: "Du hast noch kein Konto?",
	link: "Registrieren"
};
var validation = {
	email: {
		invalid: "Bitte gültige E-Mail-Adresse eingeben"
	},
	password: {
		required: "Passwort ist erforderlich",
		min: "Passwort muss länger sein als 8 Zeichen",
		number: "Passwort muss eine Zahl enthalten",
		upper: "Passwort muss einen Großbuchstaben enthalten",
		special: "Passwort muss ein Sonderzeichen enthalten"
	},
	username: {
		invalid: "Name muss mindestens 5 Zeichen enthalten"
	},
	code: {
		minmax: "Code muss 6 bis 10 Zeichen enthalten"
	}
};
var poweredBy = "Powered by <company>Streamlabs</company>";
var card = {
	"404": {
		title: "Unternehmen nicht gefunden!",
		desc: "Bitte versuche es später erneut oder wende dich an den Support."
	},
	company: {
		logoAlt: "{company} Logo"
	}
};
var checkTfaForm = {
	tfaCodePlaceholder: "6-stelliger Authentifizierungscode/8-stelliger Backup-Code",
	successText: "Erfolgreich! Weiterleiten...",
	remember: "Dieses Gerät für 30 Tage speichern"
};
var createTfa = {
	scan: {
		title: "Zwei-Faktor-Authentifizierung aktivieren",
		lead: "Klicke/kopiere oder scanne den Code unten mit deiner bevorzugten Authentifizierungs-App. Wir empfehlen, deine Codes sicher mit einer App wie <app0 />, <app1 /> oder <app2 /> zu speichern.",
		copied: "Kopiert",
		instructions: "Oder gib diesen Code manuell in deine Authentifzierungs-App ein.",
		copy: "Code kopieren",
		proceed: "Bestätigung"
	},
	confirm: {
		title: "2-Faktor-Authentifizierung bestätigen",
		lead: "Sende einen generierten 2FA-Code unten, um die 2-Faktor-Authentifizierung zu bestätigen und zu aktivieren.",
		label: "Code für 2-Faktor-Authentifizierung (6 Ziffern)",
		verify: "Code prüfen",
		next: "Erfolgreich! Nächster Schritt"
	},
	save: {
		title: "Wiederherstellungscodes speichern",
		lead: "Speichere deine Wiederherstellungscodes unten für den Fall, dass du den Zugang zu deiner 2-Faktor-Authentifizierung verlierst. Nachdem du dieses modale Dialogfeld schließt, werden diese Codes kein weiteres Mal bereitgestellt.",
		label: "Wiederherstellungscodes",
		download: "Wiederherstellungscodes herunterladen",
		copied: "Codes kopiert!",
		finished: "Fertiggestellt"
	}
};
var emailLoginForm = {
	buttonText: "Einloggen",
	emailPlaceholder: "E-Mail",
	passwordPlaceholder: "Passwort"
};
var emailSignupForm = {
	buttonText: "Registrieren",
	emailPlaceholder: "E-Mail-Adresse festlegen",
	passwordPlaceholder: "Passwort festlegen",
	usernamePlaceholder: "Dein Name",
	ageLabel: "Geburtsdatum",
	agePlaceholder: "MM/TT/JJJJ",
	agreeText: "Ich stimme den <terms>Nutzungsbedingungen</terms> und der <privacy>Datenschutzerklärung</privacy> von Streamlabs zu.",
	agreeError: "Bitte stimme den Nutzungsbedingungen von Streamlabs zu"
};
var ageInput = {
	invalidDate: "Bitte gib einen gültigen Geburtstag ein",
	futureDate: "Das Geburtsdatum muss in der Vergangenheit liegen",
	minDate: "Daten vor dem Jahr {year} sind nicht erlaubt",
	minAge_one: "Du musst mindestens {years} Jahre alt sein, um Streamlabs zu nutzen.",
	minAge_two: "Du musst mindestens {years} Jahre alt sein, um Streamlabs zu nutzen.",
	minAge_other: "Du musst mindestens {years} Jahre alt sein, um Streamlabs zu nutzen."
};
var forgotPasswordForm = {
	emailPlaceholder: "E-Mail",
	back: "Zurück zum Login",
	successText: "Erfolgreich! Wir haben dir einen Code zum Zurücksetzen deines Passworts gesendet",
	buttonText: "E-Mail-Rücksetzung beantragen",
	create: {
		successText: "Erfolgreich! Wir haben dir einen Bestätigungscode gesendet, um dir den Einstieg zu erleichtern!",
		buttonText: "Bestätigungscode anfordern"
	},
	errors: {
		notFound: "Kein Konto mit dieser E-Mail-Adresse gefunden"
	}
};
var forgotPasswordCard = {
	forgot: {
	},
	title: "Passwort vergessen?",
	lead: "Wenn du dein Passwort zurücksetzen musst, gib unten deine E-Mail-Adresse ein. Wir senden dir dann eine E-Mail, damit du den Vorgang beginnen kannst.",
	resetTitle: "Passwort zurücksetzen",
	resetLead: "Du müsstest per E-Mail einen Code erhalten haben. Fülle das Formular aus, um dein Passwort zurückzusetzen.",
	create: {
		title: "Passwort erstellen",
		lead: "Herzlichen Glückwunsch! Du hast deine Streamlabs ID erstellt! Noch ein Schritt, und du kannst dich überall auf Streamlabs einloggen!",
		resetTitle: "Passwort wählen",
		resetLead: "Du müsstest per E-Mail einen Code erhalten haben. Verwende diesen und fülle das Formular aus, um dein Passwort festzulegen."
	},
	successText: "Erfolgreich! Weiterleiten...",
	signInTitle: "Du hast schon ein Konto?",
	signInBtn: "Einloggen"
};
var checkTfaCard = {
	title: "Prüfung der Zwei-Faktor-Authentifizierung",
	lead: "Bitte gib unten einen 2-Faktor-Authentifizierungscode ein, um fortzufahren.",
	successText: "2FA erfolgreich bestätigt!",
	back: "Zurück"
};
var verifyEmailCard = {
	title: "E-Mail-Adresse bestätigen",
	lead: "Suche in deiner E-Mail nach einem 8-stelligen Code von Streamlabs und gib ihn unten ein.",
	back: "Zurück",
	successText: "E-Mail-Adresse erfolgreich überprüft!"
};
var upgradeCard = {
	confirm: {
		title: "Verbindung für {company} bestätigen",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"In Zukunft wird es möglich sein, sich mit der angegebenen E-Mail-Adresse und dem Passwort bei {company} einzuloggen.",
			"Du kannst mithilfe deiner ID auf alle anderen Produkte von Streamlabs zugreifen und etwaige weitere bestehende Konten verknüpfen.",
			"Die Änderung hat keine Auswirkungen auf dein {company} Konto."
		],
		button: "Bestätigen",
		cancel: "Abbrechen",
		switchAccount: "Konto wechseln",
		success: "Verbindung wird hergestellt..."
	},
	confirmed: {
		title: "Erfolgreich!",
		subtitle: "Deine Streamlabs ID wurde erstellt und dein {company} Konto ist verbunden.",
		text: "Du kannst deine Streamlabs ID für alle Streamlabs Produkte verwenden. Falls du bereits Konten hast, kannst du sie innerhalb jeder App mit dieser ID verknüpfen.",
		button: "Schließen"
	},
	error: {
		user: "Benutzeridentifikation ist fehlgeschlagen. Bitte versuche es erneut, dich einzuloggen, oder wende dich an den Support."
	}
};
var confirmCard = {
	confirm: {
		title: "Verbindung für {company} bestätigen",
		subtitle: "Wir haben ein Konto mit dazu passender E-Mail-Adresse gefunden. Möchtest du dieses Konto mit der Streamlabs ID zusammenführen?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Es wird möglich sein, sich mit der über die Streamlabs ID angegebenen E-Mail-Adresse und dem Passwort bei {company} einzuloggen.",
			"Du kannst mithilfe deiner ID auf alle anderen Produkte von Streamlabs zugreifen und etwaige weitere bestehende Konten verknüpfen.",
			"Die Änderung hat keine Auswirkungen auf dein Unternehmenskonto."
		],
		button: "Bestätigen",
		cancel: "Abbrechen",
		switchAccount: "Konto wechseln",
		success: "Verbindung wird hergestellt..."
	},
	confirmed: {
		title: "Erfolgreich!",
		subtitle: "Deine Streamlabs ID wurde erstellt und dein {company} Konto ist verbunden.",
		text: "Du kannst deine Streamlabs ID für alle Streamlabs Produkte verwenden. Falls du bereits Konten hast, kannst du sie innerhalb jeder App mit dieser ID verknüpfen.",
		button: "Schließen"
	},
	error: {
		user: "Benutzeridentifikation ist fehlgeschlagen. Bitte versuche es erneut, dich einzuloggen, oder wende dich an den Support."
	}
};
var upgradeConfirmCard = {
	confirm: {
		title: " Mit deiner ID ist bereits ein {company} Konto verbunden",
		subtitle: "Möchtest du die Verknüpfung des verbundenen Kontos trennen und stattdessen dein aktuelles Streamlabs Konto verknüpfen?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Es wird möglich sein, sich mit der für die Streamlabs ID angegebenen E-Mail-Adresse und dem Passwort bei Streamlabs einzuloggen.",
			"Du kannst mithilfe deiner ID auf alle anderen Produkte von Streamlabs zugreifen und etwaige weitere bestehende Konten verknüpfen.",
			"Die Änderung hat keine Auswirkungen auf dein Streamlabs Konto."
		],
		button: "Bestätigen",
		cancel: "Abbrechen",
		switchAccount: "Konto wechseln",
		success: "Verbindung wird hergestellt...",
		agreeLabel: "Mir ist bewusst, dass ich durch die Herstellung dieser Verbindung den Zugang zum bestehenden {company} mit Streamlabs ID verknüpften Konto verliere."
	},
	confirmed: {
		title: "Erfolgreich!",
		subtitle: "Deine Streamlabs ID wurde erstellt und dein {company} Konto ist verbunden.",
		text: "Du kannst deine Streamlabs ID für alle Streamlabs Produkte verwenden. Falls du bereits Konten hast, kannst du sie innerhalb jeder App mit dieser ID verknüpfen.",
		button: "Schließen"
	},
	error: {
		user: "Benutzeridentifikation ist fehlgeschlagen. Bitte versuche es erneut, dich einzuloggen, oder wende dich an den Support."
	}
};
var loginCard = {
	title: "Einloggen",
	lead: "Einloggen bei <company>{company}</company> mit <id>Streamlabs ID</id>",
	accountExists: "Du scheinst eine <b>Streamlabs ID</b> zu haben. Versuche dich mit deiner E-Mail-Adresse einzuloggen.",
	forgotPassword: "Passwort vergessen?",
	successText: "Erfolgreich! Weiterleiten...",
	signInTitle: "Über Plattform einloggen"
};
var loginSourcesCard = {
	title: "Einloggen",
	lead: "Mit E-Mail/Passwort einloggen",
	withSlId: "Mit Streamlabs ID einloggen",
	noAccountMessage: "Wir können kein Konto finden, das mit dieser Login-Methode verknüpft ist. Bitte versuche es mit einer anderen Login-Methode oder <signup>registriere</signup> dich, falls du dies noch nicht getan hast.",
	accountExistsMessage: "Deine E-Mail-Adresse für Twitch ist bereits mit Streamlabs verknüpft. Versuche, dich mit deiner Streamlabs E-Mail-Adresse und deinem Passwort anzumelden."
};
var resetPasswordForm = {
	emailPlaceholder: "E-Mail",
	codePlaceholder: "E-Mail-Code, 6- bis 8-stellig",
	tfaCodePlaceholder: "2F-Authenticator-Code",
	newPasswordPlaceholder: "Neues Passwort",
	tfaError: "Der Code zum Zurücksetzen muss 6 bis 10 Zeichen enthalten",
	next: "Code erhalten?",
	back: "Zurück zu „Passwort vergessen“",
	buttonText: "Passwort ändern",
	successText: "Passwort erfolgreich geändert",
	create: {
		back: "Zurück zum Anfang",
		buttonText: "Passwort festlegen",
		successText: "Passwort erfolgreich eingerichtet"
	}
};
var changePasswordForm = {
	currentPasswordPlaceholder: "Aktuelles Passwort",
	newPasswordPlaceholder: "Neues Passwort",
	newPasswordConfirmationPlaceholder: "Neues Passwort bestätigen",
	buttonText: "Passwort ändern",
	successText: "Passwort erfolgreich aktualisiert",
	newPasswordConfirmationError: "Neue Passwörter stimmen nicht überein",
	back: "Zurück zu Dashboard"
};
var changePasswordCard = {
	title: "Ändere dein Passwort",
	lead: "Gib unten dein aktuelles und ein neues Passwort ein.",
	successText: "Passwort erfolgreich aktualisiert"
};
var removeTfaForm = {
	tfaCodePlaceholder: "6-stelliger Authentifizierungscode/8-stelliger Backup-Code",
	successText: "2FA erfolgreich entfernt",
	removeBtn: "Bestätigen und entfernen"
};
var removeTfaCard = {
	title: "Zwei-Faktor-Authentifizierung entfernen",
	lead: "Gib unten einen 2FA-Bestätigungscode ein, um die Zwei-Faktor-Authentifizierung aus deinem Konto zu entfernen.",
	successText: "2FA erfolgreich entfernt",
	back: "Zurück zu Dashboard"
};
var verifyEmailForm = {
	codePlaceholder: "8-stelliger Code aus E-Mail",
	tfaCodePlaceholder: "2F-Authenticator-Code",
	emailPlaceholder: "E-Mail-Adresse",
	buttonText: "E-Mail überprüfen",
	successText: "E-Mail-Adresse erfolgreich überprüft",
	requestBtn: "Neuen Code anfordern",
	requestingBtn: "Anfordern...",
	requestSuccess: "Ein Code wurde an deine E-Mail-Adresse gesendet",
	requestAgain: "Erneut anfordern nach: {seconds}",
	tfaError: "Der Code zum Zurücksetzen muss 6 bis 10 Zeichen enthalten",
	back: "Zurück"
};
var signupCard = {
	title: "Registrieren",
	lead: "Erstelle ein <id>Streamlabs ID</id> Konto zur Verwendung von <company>{company}</company>",
	successText: "Erfolgreich! Weiterleiten..."
};
var signupSourcesCard = {
	title: "Registrieren",
	lead: "Erstelle ein <id>Streamlabs ID</id> Konto zur Verwendung von <company>{company}</company>",
	withSlId: "Streamlabs ID erstellen"
};
var connectCard = {
	connect: {
		title: "Konto wählen",
		lead: "zum Fortsetzen mit <b>{company}</b>",
		authorize: "Autorisieren",
		authorizeSuccess: "Erfolgreich!",
		cancel: "Abbrechen",
		disclaimer: {
			streamlabs: "Wenn du dies fortsetzt, wird deine Streamlabs ID (Name, E-Mail-Adresse, Spracheinstellungen und Profilbild) an <b>{company}</b> weitergegeben. Durch Autorisieren eines Kontos bei <b>{company}</b> stimmst du <b>{company}</b>s <privacy>Datenschutzerklärung</privacy> und <terms>Nutzungsbedingungen </terms> zu.",
			"default": "Um fortzufahren, wird Streamlabs deinen Namen, deine E-Mail-Adresse, deine Spracheinstellungen und dein Profilbild an <b>{company}</b> weitergeben. Durch Autorisieren eines Kontos bei <b>{company}</b> stimmst du <b>{company}</b>s <privacy>Datenschutzerklärung</privacy> und <terms>Nutzungsbedingungen </terms> zu."
		},
		emailRequired: "E-Mail-Prüfung erforderlich zum Fortsetzen",
		tfaRequired: "2-Faktor Authentifizierung erforderlich zum Fortsetzen"
	},
	login: {
		title: "Einloggen bei {company}",
		lead: "Du musst eingeloggt sein, um Konten zu verbinden",
		loginBtn: "Weiter zum Login"
	},
	error: {
		title: "Einloggen bei {company}",
		lead: "Deine Anfrage kann derzeit nicht autorisiert werden.",
		verifyEmail: "E-Mail überprüfen",
		verify2fa: "2FA-Prüfung"
	},
	"switch": {
		btn: "Anderes Konto verwenden"
	}
};
var appsDropdown = {
	label: "Streamlabs Produkte und Apps",
	viewMore: "Erweitern",
	viewLess: "Reduzieren"
};
var platformButtons = {
	loginWithPlatform: "Über Plattform einloggen",
	signUpWithPlatform: "Über Plattform registrieren",
	signUpLead: "Wir unterstützen Live-Streaming auf vielen weiteren Plattformen, doch als Registrierungsoptionen bieten wir nur diese an."
};
var ultraCheckoutCard = {
	title: "Mach deine Live-Streams, dein Branding, dein Editing und vieles mehr noch besser mit <b>Streamlabs Ultra</b>",
	badge: "Enthält <b>{planName}</b>",
	totalValue: "{price, currency} Wert",
	price: {
		month: "{price, currency}/Mon",
		year: "{price, currency}/Jr"
	},
	description: {
		month: "Greife auf die Premium-Funktionen der gesamten Suite zu, einschließlich <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> und mehr, zu einem günstigen Preis.",
		year: "Greife auf die Premium-Funktionen der gesamten Suite zu, einschließlich <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> und mehr, zu einem günstigen Preis."
	},
	seeIncluded: "Mehr erfahren",
	buyNow: "Upgrade"
};
var ultraCheckoutBanner = {
	title: "Mach deine Live-Streams, dein Branding, dein Editing und vieles mehr noch besser mit <b>Streamlabs Ultra</b>",
	badge: "Enthält <b>{planName}</b>",
	totalValue: "{price, currency} Wert",
	price: {
		month: "{price, currency}/Mon",
		year: "{price, currency}/Jr"
	},
	description: {
		month: "Greife auf die Premium-Funktionen der gesamten Suite zu, einschließlich <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> und mehr, zu einem günstigen Preis. <link />",
		year: "Greife auf die Premium-Funktionen der gesamten Suite zu, einschließlich <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> und mehr, zu einem günstigen Preis. <link />"
	},
	seeIncluded: "Mehr erfahren",
	buyNow: "Upgrade"
};
var connect = {
	waitMessage: "Daten werden zusammengeführt. Bitte schließe dieses Fenster nicht."
};
var verifyPasswordCard = {
	success: "Passwort erfolgreich verifiziert",
	title: "Bitte authentifiziere dich zur Bestätigung erneut",
	lead: "Melde dich mit deiner bestehenden E-Mail-Adresse und deinem Passwort an, um deine Streamlabs ID zu aktualisieren.",
	buttonText: "Weiter"
};
var emailChangeForm = {
	agreeError: "Bitte bestätige, dass du diese Aktion verstehst",
	buttonText: "Weiter",
	emailPlaceholder: "Neue E-Mail-Adresse",
	agreeText: "Ich habe verstanden, dass sich meine Streamlabs ID nach der Verifizierung in allen Streamlabs Produkten ändert, mit denen sie verbunden ist."
};
var verifyNewEmailCard = {
	title: "Streamlabs ID ändern",
	lead: "Gib eine neue E-Mail-Adresse an, um sie als deine Streamlabs ID zu verwenden. Wir senden einen 6–8-stelligen Verifizierungscode an diese Adresse.",
	successText: "Neue E-Mail verfügbar"
};
var verifyNewEmailOwnershipCard = {
	title: "Überprüfe deine aktualisierte Streamlabs ID",
	lead: "Suche in deiner E-Mail nach einem 8-stelligen Code von Streamlabs und gib ihn unten ein.",
	buttonText: "Bestätigen",
	back: "Zurück",
	codePlaceholder: "8-stelliger Code aus E-Mail",
	successText: "E-Mail-Eigentum erfolgreich verifiziert"
};
var verifyTfaCard = {
	title: "Code für Zwei-Faktor-Authentifizierung",
	lead: "Gib den 6-stelligen Verifizierungscode aus deiner Authentifizierungs-App ein.",
	codePlaceholder: "6-stelliger Code",
	buttonText: "Bestätigen",
	successText: "2-Faktor-Authentifizierung bestätigt",
	back: "Zurück"
};
var ageGateForm = {
	ageLabel: "Geburtsdatum",
	agePlaceholder: "MM/TT/JJJJ"
};
var ageGateCard = {
	title: "Kontoeinrichtung abschließen",
	lead: {
		years: "Du musst {years} oder älter sein, um ein Konto zu erstellen. <br />Gib dein Geburtsdatum ein, um die Einrichtung abzuschließen.",
		noYears: "Du musst dein Geburtsdatum angeben, um ein Konto zu erstellen. <br />Gib es ein, um die Einrichtung abzuschließen."
	},
	successText: "Glückwunsch! Kontoeinrichtung abgeschlossen."
};
var deDE = {
	actions: actions,
	errors: errors,
	brands: brands,
	loginButton: loginButton,
	alreadyHaveAccount: alreadyHaveAccount,
	noAccount: noAccount,
	validation: validation,
	poweredBy: poweredBy,
	card: card,
	checkTfaForm: checkTfaForm,
	createTfa: createTfa,
	emailLoginForm: emailLoginForm,
	emailSignupForm: emailSignupForm,
	ageInput: ageInput,
	forgotPasswordForm: forgotPasswordForm,
	forgotPasswordCard: forgotPasswordCard,
	checkTfaCard: checkTfaCard,
	verifyEmailCard: verifyEmailCard,
	upgradeCard: upgradeCard,
	confirmCard: confirmCard,
	upgradeConfirmCard: upgradeConfirmCard,
	loginCard: loginCard,
	loginSourcesCard: loginSourcesCard,
	resetPasswordForm: resetPasswordForm,
	changePasswordForm: changePasswordForm,
	changePasswordCard: changePasswordCard,
	removeTfaForm: removeTfaForm,
	removeTfaCard: removeTfaCard,
	verifyEmailForm: verifyEmailForm,
	signupCard: signupCard,
	signupSourcesCard: signupSourcesCard,
	connectCard: connectCard,
	appsDropdown: appsDropdown,
	platformButtons: platformButtons,
	ultraCheckoutCard: ultraCheckoutCard,
	ultraCheckoutBanner: ultraCheckoutBanner,
	connect: connect,
	verifyPasswordCard: verifyPasswordCard,
	emailChangeForm: emailChangeForm,
	verifyNewEmailCard: verifyNewEmailCard,
	verifyNewEmailOwnershipCard: verifyNewEmailOwnershipCard,
	verifyTfaCard: verifyTfaCard,
	ageGateForm: ageGateForm,
	ageGateCard: ageGateCard
};

export { deDE as d };
//# sourceMappingURL=de-DE.es.js.map
